export type Unsubscribe = () => void;

/**
 * Подписка на CustomEvent событий M.
 * - M — карта: имя события -> тип detail.
 * - K — конкретное имя события из M.
 *
 * Возвращает функцию отписки (unsubscribe).
 */
export const onCustomEvent = <
  M extends Record<string, unknown>,
  K extends keyof M & string = keyof M & string
>(
  target: EventTarget,
  name: K,
  cb: (e: CustomEvent<M[K]>) => void,
  options?: boolean | AddEventListenerOptions
): Unsubscribe => {
  const handler: EventListener = (e) => cb(e as CustomEvent<M[K]>);
  target.addEventListener(name, handler, options as any);
  const capture = typeof options === 'boolean' ? options : options?.capture;
  return () => target.removeEventListener(name, handler, capture);
};
